"use client";

import BlogMaintenance from "@components/features/blog/BlogMaintenance";

/**
 * Error boundary for /blog — in practice, a WordPress outage.
 *
 * Why the page throws instead of returning this view with a 200:
 *
 * Google's guidance for downtime is to answer with a server error, so the
 * crawler retries later and the URL keeps its ranking. A 200 carrying a
 * maintenance notice risks that notice being indexed as the page's content or
 * being read as a soft 404, and `noindex` is worse still — it is the signal for
 * "remove this permanently", which is exactly what must not happen to a page
 * that is coming back in an hour. A redirect is the worst of the three: it
 * tells Google the listing has moved to the error page.
 *
 * Next's App Router cannot set a status code from a page, so the throw is what
 * produces the 5xx. A true 503 with Retry-After needs middleware or the ingress
 * in front of the app.
 *
 * Note that Next stamps its own `<meta name="robots" content="noindex">` onto
 * the error shell. That is harmless here and must not be "fixed" by forcing
 * index metadata: it rides along with a 5xx, whose body Google does not read
 * for indexing decisions. It is only a self-inflicted `noindex` on a *200*
 * that removes a URL from the index.
 */
export default function BlogError() {
  return <BlogMaintenance locale="de" />;
}
